<script lang="ts">
  import { onMount } from 'svelte';

  import { _ } from 'svelte-i18n';
  import flagKeys from '../../../etc/flagKeys';
  import { AppState, SetNotification } from '../../../etc/stores';
  import type { ICoupon } from '../../../etc/types';
  import {
    formatMoney,
    isMobile,
    removeTrailingZeros
  } from '../../../etc/utils';
  import { replaceVariables } from '../../../i18n';
  import Analytics from '../../../services/analytics';

  const NAME =
    $AppState.customer?.name || $AppState.auth.providerData?.firstName;

  let value = '';
  let isFreeCoins = false;
  let category = 'free-coins-state';

  $: {
    isFreeCoins =
      !!$AppState.freeCoinsCampaign.id &&
      !$AppState.freeCoinsCampaign.alreadyRedeemed;
    category = isFreeCoins ? 'free-coins-state' : 'logged-in-state';

    if (isFreeCoins) {
      value = formatMoney(
        $AppState.business.location,
        $AppState.freeCoinsCampaign.coinsReward || 0,
        false
      );
    } else if ($AppState.coupons.length) {
      const coupon: ICoupon = $AppState.coupons
        .filter(coupon => coupon.status === 'active')
        .reduce(function (prev, current) {
          return prev.moneyValue > current.moneyValue ? prev : current;
        });

      if (coupon) {
        value = removeTrailingZeros(coupon.formattedMoneyAmount);
      }
    }
  }

  const t = (text: string, values?: any) => {
    return replaceVariables($_(`messages.remind_checkout.${text}`), values);
  };

  const onClick = () => {
    if (isFreeCoins) {
      SetNotification('welcomeCoinAvailable', true);
    } else {
      SetNotification('', true);
      AppState.update(state => ({
        ...state,
        website: {
          ...state.website,
          popoverOpen: true,
          popoverRouteOnOpen: {
            route: '/payment-codes'
          }
        }
      }));
    }
  };

  const getMessage = message => {
    if (isMobile()) return message.replace('<br/>', ' ');
    return message;
  };

  const getI18nText = () => {
    return isFreeCoins ? '_welcome_coins' : '_coins';
  };

  onMount(() => {
    Analytics.logEvent('cart-coupon-trigger', category);
  });
</script>

<p on:click={() => onClick()}>
  {@html getMessage(
    t(`message${getI18nText()}`, {
      AMOUNT: value,
      NAME
    })
  )}
</p>

<style lang="scss">
  @use './styles.scss' as *;
</style>
